<template>
  <div class="m-payment-options">
    <h2 class="m-payment-options__headline h4">
      {{ $t("paymentOptionsHeadline", "Betalingsmetode") }}
    </h2>
    <div
      v-for="(paymentOption, index) in allowedPaymentOptions"
      :key="index"
      class="d-flex t-checkout-page__fields-container-payments"
    >
      <base-radio
        v-model="localValue"
        name="creditcard"
        :value="paymentOption.id.toString()"
      >
        <template v-slot:label>
          <div class="a-radio__label -payment-radio">
            <!-- <base-image
              :url="`/payment-icons/${paymentOption.name.toLowerCase().replace('/', '-').replace(' ', '-')}.png`"
              :width="60"
              :height="25"
              :alt-text="`${paymentOption.name}`"
              :include-cdn="false"
              :class="`mr-5`"
              :is-lazy-load="false"
            /> -->
            {{ paymentOption.displayName }}
          </div>
        </template>
      </base-radio>
    </div>
  </div>
</template>

<script>
import BaseRadio from '@/components/atoms/BaseRadio.vue';
import loginMixin from '@/mixins/loginMixin'
// import BaseImage from '@/components/atoms/BaseImage.vue';

export default {
  name: 'PaymentOptions',
  components: {
    BaseRadio,
    // BaseImage
  },
  mixins: [loginMixin],
  props: {
    value: {
      type: String,
      required: true
    },
    creditCardName: {
      type: String,
      default: ''
    },
    invoiceName: {
      type: String,
      default: ''
    },
    isAnotherAddressSelected: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    paymentOptions () {
      return this.$store.getters['checkout/checkout/getPaymentOptions'];
    },
    allowedPaymentOptions () {
      const currentAllowedPaymentOptions = [
        this.creditCardName
      ];
      if (this.isLoggedIn && !this.isAnotherAddressSelected) {
        currentAllowedPaymentOptions.push(this.invoiceName);
      }

      return this.paymentOptions.filter((paymentOption) => currentAllowedPaymentOptions.includes(paymentOption.name));
    },
    localValue: {
      get () {
        return this.value;
      },
      set (localValue) {
        this.$emit('input', localValue);
      }
    }
  },
  watch: {
    allowedPaymentOptions () {
      this.pickFirstPaymentOption();
    }
  },
  async mounted () {
    await this.$store.dispatch('checkout/checkout/fetchPaymentOptions');
    this.pickFirstPaymentOption();
  },
  methods: {
    pickFirstPaymentOption () {
      this.$emit('input', this.allowedPaymentOptions[0].id.toString());
    }
  }
}
</script>
